import { useLanguageTranslator } from "hooks/use-language-translator";
import styles from "./styles.module.scss";
import { InputField } from "../add-template/input-field";
import { useEffect, useState } from "react";
import { message, Select, Spin } from "antd";
import { DropdownSuffix } from "icons";
import { UseLazyApiCallV2 } from "hooks";

export const ReminderDetail = ({
  reminderData,
  closeReminderDetail,
  refetchReminderHistory,
  loading,
  refetchCount,
}) => {
  const { translator } = useLanguageTranslator();
  const reminderFormTrans = translator("caseDetail.reminder.form");
  const reminderTableTrans = translator("caseDetail.reminder.historyTable");
  const reminderTrans = translator("caseDetail.reminder");
  const [description, setDescription] = useState();
  const [reminderStatus, setReminderStatus] = useState();
  const [
    updateReminderStatus,
    {
      data: updateReminderStatusData,
      isLoading: updateReminderStatusLoading,
      error: updateReminderStatusError,
    },
  ] = UseLazyApiCallV2({
    url: "/update_reminder_status",
    method: "POST",
  });
  const [
    updateReminder,
    {
      data: updateReminderData,
      isLoading: updateReminderLoading,
      error: updateReminderError,
    },
  ] = UseLazyApiCallV2({
    url: "/edit_email_reminder",
    method: "POST",
  });

  useEffect(() => {
    if (reminderData) {
      const { description, status } = reminderData || {};
      setDescription(description);
      setReminderStatus(status);
    }
  }, [reminderData]);

  const inputFields = [
    {
      name: "assigneeName",
      title: reminderFormTrans.name,
      type: "text",
      disabled: true,
    },
    {
      name: "assignedTo",
      title: reminderFormTrans.email,
      type: "text",
      disabled: true,
    },
    {
      name: "title",
      title: reminderFormTrans.title,
      type: "text",
      disabled: true,
    },
    {
      name: "subject",
      title: reminderFormTrans.subject,
      type: "text",
      disabled: true,
    },
    {
      name: "category",
      title: reminderFormTrans.category,
      type: "text",
      disabled: true,
    },
    {
      name: "description",
      title: reminderFormTrans.description,
      placeholder: "Enter description",
      type: "text",
    },
  ];

  function handleChangeTextEditor(content) {
    setDescription(content);
  }

  const statusOptions = [
    {
      label: reminderTableTrans.PENDING,
      value: "PENDING",
    },
    {
      label: reminderTableTrans.DONE,
      value: "DONE",
    },
  ];

  async function handleSelectStatus(status) {
    setReminderStatus(status);
    try {
      const res = await updateReminderStatus({
        params: {
          reminder_id: reminderData?.id,
          status,
        },
      });

      if (res?.status === "Success") {
        message.success(res?.message);
        if (refetchCount) {
          refetchCount();
        }
        refetchReminderHistory();
      }
    } catch (error) {
      console.log({ error });
    }
  }
  async function handleUpdateReminder() {
    try {
      const res = await updateReminder({
        params: {
          reminder_id: reminderData?.id,
          description,
        },
      });
      if (res?.status === "Success") {
        message.success(res?.message);
        refetchCount();
        refetchReminderHistory();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <Spin
      spinning={loading || updateReminderLoading || updateReminderStatusLoading}
    >
      <div className={styles.reminderDetail}>
        <div className={styles.titleAndStatusUpdate}>
          <div className={styles.title}>{reminderTrans.viewReminder}</div>
          <div className={styles.statusUpdate}>
            <div className={styles.label}>{translator("status")}:</div>
            <div
              className={`${styles.dropdown} ${reminderStatus === "PENDING" ? styles.pending : ""}`}
            >
              <Select
                defaultValue={reminderStatus}
                value={reminderStatus}
                style={{
                  width: "140px",
                  height: "4.3dvh",
                }}
                onSelect={handleSelectStatus}
                options={statusOptions}
                suffixIcon={<DropdownSuffix />}
              />
            </div>
          </div>
        </div>
        <div className={styles.fields}>
          {inputFields.map((item) => (
            <InputField
              key={item.name}
              placeholder={item.placeholder}
              name={item.name}
              title={item.title}
              value={
                (item.name === "description"
                  ? description
                  : item.name === "category"
                    ? translator("caseDetail.form")[reminderData?.[item.name]]
                    : reminderData?.[item.name]) || ""
              }
              type={item.type}
              handleChangeTextEditor={handleChangeTextEditor}
              isQuill={item.name === "description"}
              disabled={item.disabled}
              QuilHeight="30dvh"
            />
          ))}
        </div>
        <div className={styles.downloadBtnContainer}>
          <button
            type="button"
            onClick={closeReminderDetail}
            style={{
              backgroundColor: "white",
            }}
          >
            <span style={{ color: "#cd2a3f" }}>{translator("cancel")}</span>
          </button>
          <button type="button" onClick={handleUpdateReminder}>
            <span>{translator("update")}</span>
          </button>
        </div>
      </div>
    </Spin>
  );
};
